import { useState, useReducer, useEffect, useRef } from "react";
import DataGrid, {
  Column,
  Lookup,
  Paging,
  Pager,
  RequiredRule,
} from "devextreme-react/data-grid";
import Switch from "devextreme-react/switch";
import FileUploader from "devextreme-react/file-uploader";
import RadioGroup from "devextreme-react/radio-group";
import Button from "devextreme-react/button";
import { compact, isArray, isEmpty } from "lodash";
import { confirm, alert } from "devextreme/ui/dialog";
import { TextBox } from "devextreme-react";

import { CONFIG } from "./config";
import ManageSiteImage from "../common/manageSiteImage/ManageSiteImage";
import { getTypeOfFile, fileTypeInfo } from "../../common/utils";
import TagBox from "devextreme-react/tag-box";
import { postUserLog } from "../../actions/common";
import * as actions from "../../actions/settings";
import settingsReducer from "../../reducers/settings";
import {
  getUpdatedRecord,
  set,
  get,
  setGridUserPrefs,
  setGridWidthPrefs,
  applyUserPref,
  saveUserPref,
} from "../../common/utils";
import {
  ALLOWED_IMAGE_EXTENSIONS,
  ALLOWED_IMAGE_MIME_TYPES,
} from "../../constants/allowedUploadTypes";
import { checkUploadFilesValid } from "../../utils/fileValidator";

const initialState = {
  siteData: null,
  tiersAboveData: [],
  LIDPlantData: [],
  TimezoneData: [],
  userPrefSettings: null,
  languagesByRegion: null,
};

const statusTxt = [
  { key: "active", val: "Active" },
  { key: "inactive", val: "Inactive" },
  { key: "wip", val: "Inprogress" },
];

const tierLevelData = [
  { key: 4, val: "" },
  { key: 5, val: "GBE" },
  { key: 6, val: "SBU" },
  { key: 7, val: "SBG" },
  { key: 8, val: "" },
];

export default ({ siteId, tierId, isSA }) => {
  const [state, dispatch] = useReducer(settingsReducer, initialState);
  let siteGridConfig = CONFIG.SITE_GRID;
  let {
    siteData,
    tiersAboveData,
    LIDPlantData,
    TimezoneData,
    userPrefSettings,
    languagesByRegion,
  } = state;
  const widgetId = "siteInfo";
  const GRID_COLS = JSON.stringify([
    "id",
    "sbgid",
    "tierLevel",
    "siteID",
    "siteUid",
    "siteName",
    "region",
    "timezone",
    "lidCode",
    "plantCode",
    "plantlid",
    "siteAddress",
    "deployStatus",
    "siteDescription",
    "nextTierName",
    "siteLatitude",
    "siteLongitude",
    "isPrivate",
    "tempUnit",
    "siteImage",
    "upcomingEvent",
    "childTiers",
    "isSiteActive",
  ]);
  const loggedinUser = get("hid");
  const basePath = window.location.origin;
  const siteDataGrid = useRef(null);

  let filteredLID = useState({});

  useEffect(() => {
    if (!isSA) actions.fetchSiteList(dispatch, siteId);
    else actions.fetchSiteLists(dispatch);

    actions.fetchTiersAbove(dispatch, siteId);

    actions.fetchLIDandPlantData(dispatch, "undefined", 0);
    actions.fetchTimezoneInfo(dispatch);
    actions.fetchLanguagesByRegion(dispatch, "");
  }, []);

  useEffect(() => {
    actions.fetchUserPref(
      dispatch,
      `=0&SiteUID=${siteId ? siteId : "AdminConsole"}&widgetID=${widgetId}`
    );
    return () => {
      actions.updateUserPref(
        dispatch,
        saveUserPref({
          widgetId,
          siteId: siteId ? siteId : "AdminConsole",
          tierId: 0,
          moduleName: widgetId,
          loggedinUser,
          prefSess: "userPrefSettings",
          GRID_COLS,
        })
      );
    };
  }, []);

  useEffect(() => {
    if (userPrefSettings) set("userPrefSettings", userPrefSettings);
    if (
      siteDataGrid &&
      siteDataGrid.current &&
      siteDataGrid.current.instance !== null &&
      userPrefSettings &&
      siteData
    ) {
      applyUserPref(siteDataGrid, userPrefSettings);
    }
  }, [userPrefSettings, siteData]);

  // if (LIDPlantData) {
  //   let data = Array.isArray(LIDPlantData.lidPlant)
  //     ? LIDPlantData.lidPlant
  //         .filter((d) => {
  //           return d.type == "LIDPlant";
  //         })
  //         .map((dtls) => ({
  //           id: dtls.lid,
  //           LidCode: dtls.lid,
  //         }))
  //     : [];

  //   let array = [{ store: { type: "array", data, key: "name" } }];

  //   filteredLID = [...new Set(array)];

  //   if (filteredLID[0]) {
  //     let data = Array.isArray(LIDPlantData.lidPlant)
  //       ? LIDPlantData.lidPlant
  //           .filter((d) => {
  //             return d.type == "LIDPlant";
  //           })
  //           .map((dtls) => ({
  //             id: Math.floor(Math.random() * Math.pow(10, 7)),
  //             plant: dtls.plant,
  //           }))
  //       : [];

  //     let formatPlant = [{ store: { type: "array", data, key: "name" } }];

  //     filteredPlant = [...new Set(formatPlant)];
  //   }

  //   if (LIDPlantData) {
  //     let data = Array.isArray(LIDPlantData.lidPlant)
  //       ? LIDPlantData.lidPlant
  //           .filter((d) => {
  //             return d.type === "ChildTiers";
  //           })
  //           .map((dtls) => ({
  //             id: dtls.siteUID,
  //             siteUID: dtls.siteUID,
  //           }))
  //       : [];

  //     let formatSiteUID = [{ store: { type: "array", data, key: "name" } }];

  //     filteredSiteUID = [...new Set(formatSiteUID)];
  //   }
  // }

  const isPrivateCellRender = (cellInfo) => {
    return (
      <Switch
        defaultValue={cellInfo.data.value}
        onValueChanged={(e) => cellInfo.data.setValue(e.value)}
        switchedOffText="OFF"
        switchedOnText="ON"
      ></Switch>
    );
  };

  const isActiveCellRender = (cellInfo) => {
    return (
      <Switch
        defaultValue={cellInfo.data.value}
        onValueChanged={(e) => cellInfo.data.setValue(e.value)}
        switchedOffText="OFF"
        switchedOnText="ON"
      ></Switch>
    );
  };
  const onRowUpdated = () => {
    if (!isSA) actions.fetchSiteList(dispatch, siteId);
    else actions.fetchSiteLists(dispatch);
    siteDataGrid.current.instance.refresh();
    siteDataGrid.current.instance.updateDimensions();
  };

  const onRowUpdating = (e) => {
    var newData = e.newData ? e.newData : e.data.newData;
    var oldData = e.oldData ? e.oldData : e.data.oldData;
    let diffVal = getUpdatedRecord(oldData, newData);

    const {
      siteAddress,
      siteDescription,
      siteLatitude,
      siteLongitude,
      isPrivate,
      siteImage,
      tempUnit,
      deployStatus,
      upcomingEvent,
      tierLevel,
      lidCode,
      plantlid,
      region,
      timezone,
      childTiers,
      isSiteActive,
      language,
    } = newData;

    if (isArray(siteImage)) {
      const validateUploadFiles = checkUploadFilesValid(
        siteImage,
        ALLOWED_IMAGE_MIME_TYPES
      );

      if (validateUploadFiles.length) {
        const alertMsg = validateUploadFiles.map(
          (file) => `${file.name} - ${file.reason}`
        );
        alert(alertMsg.join("<br/>"), "Alert");
        return (e.cancel = true);
      }
    }

    const { id, sbgName, sbgid, siteID, siteName } = oldData;
    let siteSps = siteId ? siteId : siteID;
    let formData = new FormData();
    formData.append("id", id);
    formData.append("siteAddress", siteAddress ? siteAddress : "");
    formData.append(
      "siteDescription",
      siteDescription ? siteDescription : oldData.siteDescription
    );
    formData.append(
      "isPrivate",
      isPrivate == true || isPrivate == false ? isPrivate : oldData.isPrivate
    );
    formData.append(
      "isSiteActive",
      isSiteActive == true || isSiteActive == false
        ? isSiteActive
        : oldData.isSiteActive
    );
    formData.append("siteImage", siteImage ? siteImage[0] : null);

    formData.append(
      "siteLatitude",
      siteLatitude ? siteLatitude : oldData.siteLatitude
    );
    formData.append(
      "siteLongitude",
      siteLongitude ? siteLongitude : oldData.siteLongitude
    );

    formData.append("tempUnit", tempUnit ? tempUnit : oldData.tempUnit);
    formData.append(
      "upcomingEvent",
      upcomingEvent ? upcomingEvent : oldData.upcomingEvent
    );
    formData.append("region", region ? region : oldData.region);
    formData.append("timezone", timezone ? timezone : oldData.timezone);
    formData.append("language", language ? language : 0);

    if (isSA) {
      let { sbgid, siteID, siteName } = newData;
      formData.append("siteID", siteID ? siteID : oldData.siteID);
      formData.append("siteName", siteName ? siteName : oldData.siteName);
      formData.append("sbgid", sbgid ? sbgid : oldData.sbgid);
      formData.append("tierLevel", tierLevel ? tierLevel : oldData.tierLevel);
      formData.append(
        "deployStatus",
        deployStatus ? deployStatus : oldData.deployStatus
      );
      formData.append("tierID", oldData.tierID);
      formData.append("siteUID", oldData.siteUid);
      // formData.append("region", region ? region : oldData.region);
      // formData.append("timezone", timezone ? timezone : oldData.timezone);
      formData.append(
        "LidCode",
        (tierLevel || oldData.tierLevel) === 4
          ? lidCode
            ? lidCode
            : oldData.lidCode
          : null
      );
      formData.append(
        "plant",
        (tierLevel || oldData.tierLevel) === 4
          ? plantlid
            ? plantlid
            : oldData.plantlid
          : null
      );
      formData.append(
        "ChildTier",
        (tierLevel || oldData.tierLevel) > 4
          ? childTiers
            ? childTiers
            : oldData.childTiers
          : null
      );
    } else {
      formData.append("sbgName", sbgName);
      formData.append("sbgid", sbgid);
      formData.append("siteID", siteSps);
      formData.append("siteName", siteName);
      formData.append("tierID", tierId);
    }

    if (!isSA)
      Object.keys(diffVal).map((v) => {
        postUserLog({
          event: "Site Update",
          data: {
            action: `Updated ${v.toUpperCase()} from ${diffVal[v].oldV} to ${
              diffVal[v].newV
            } for ${oldData.siteUid}`,
            module: "Settings",
            section: "Manage Site",
            siteUId: oldData.siteUid,
            widget: "",
          },
        });
      });
    else {
      postUserLog({
        event: "Site Update",
        data: {
          action: `${oldData.siteName} got updated for ${oldData.siteUid}`,
          module: "Admin Console",
          section: "Manage Site",
          siteUId: oldData.siteUid,
          widget: "",
        },
      });
    }
    actions.updateSiteData(dispatch, formData, siteSps, isSA);
    siteDataGrid.current.instance.refresh();
    siteDataGrid.current.instance.updateDimensions();
  };

  const onRowInserting = (e) => {
    const { siteImage } = e.data;
    if (isArray(siteImage)) {
      const validateUploadFiles = checkUploadFilesValid(
        siteImage,
        ALLOWED_IMAGE_MIME_TYPES
      );

      if (validateUploadFiles.length) {
        const alertMsg = validateUploadFiles.map(
          (file) => `${file.name} - ${file.reason}`
        );
        alert(alertMsg.join("<br/>"), "Alert");
        e.cancel = true;
      }
    }
  };

  const onRowInserted = (e) => {
    const {
      siteAddress,
      siteDescription,
      siteLatitude,
      siteLongitude,
      siteName,
      isPrivate,
      siteImage,
      tempUnit,
      upcomingEvent,
      tierLevel,
      deployStatus,
      siteID,
      sbgid,
      lidCode,
      plantlid,
      siteUid,
      siteUID,
      region,
      timezone,
      childTiers,
      isSiteActive,
    } = e.data;
    let siteSps = siteId ? siteId : siteID;
    let formData = new FormData();
    formData.append("sbgid", sbgid);
    formData.append("siteAddress", siteAddress ? siteAddress : "");
    formData.append("siteDescription", siteDescription ? siteDescription : "");
    formData.append("siteID", siteID);
    formData.append(
      "isPrivate",
      isPrivate == true || isPrivate == false ? isPrivate : false
    );
    formData.append(
      "isSiteActive",
      isSiteActive == true || isSiteActive == false ? isSiteActive : false
    );
    formData.append(
      "siteImage",
      siteImage && siteImage[0] ? siteImage[0] : null
    );
    formData.append("siteLatitude", siteLatitude);
    formData.append("siteLongitude", siteLongitude);
    formData.append("siteName", siteName);
    formData.append("tierID", tierId);
    formData.append("tempUnit", tempUnit ? tempUnit : "");
    formData.append("upcomingEvent", upcomingEvent ? upcomingEvent : "");
    if (isSA) {
      formData.append("tierLevel", tierLevel);
      formData.append("deployStatus", deployStatus);
      formData.append("LidCode", tierLevel === 4 ? lidCode : null);
      formData.append("ChildTier", tierLevel > 4 ? childTiers : null);
      formData.append("plant", tierLevel === 4 ? plantlid : null);
      formData.append("siteUID", siteUid);
      formData.append("region", region);
      formData.append("timezone", timezone);
    }
    if (!isSA) {
      postUserLog({
        event: "Site Create",
        data: {
          action: `${siteName} got added`,
          module: "Settings",
          section: "Manage Site",
          siteUId: siteId,
          widget: "",
        },
      });
    }
    actions.updateSiteData(dispatch, formData, siteSps, isSA);
  };

  const onRowRemoved = (data) => {
    let result = confirm(
      "Are you sure you want to delete the Site?",
      "Confirm changes"
    );
    result.then((res) => {
      if (res) {
        if (!isSA) {
          postUserLog({
            event: "Site Delete",
            data: {
              action: `${data.data.site} got deleted`,
              module: "Settings",
              section: "Manage Site",
              siteUId: siteId,
              widget: "",
            },
          });
        }
        actions.deleteSite(dispatch, data.data.id, siteId, isSA);
      } else {
        alert("Site Delete Action Cancelled", "Alert");
      }
    });
  };

  if (isSA) siteGridConfig.editing.allowAdding = true;
  else siteGridConfig.editing.allowAdding = false;

  const editCellRenderUpcomingEvent = (cellInfo) => {
    return (
      <RadioGroup
        style={{ fontSize: "10px" }}
        id="noOfEvents"
        defaultValue={cellInfo.data.value}
        items={CONFIG.noOfEvents}
        layout="horizontal"
        onValueChanged={(e) => cellInfo.data.setValue(e.value)}
      />
    );
  };

  const editUnitCellRender = (cellInfo) => {
    let currentValue = cellInfo.data.value === "F" ? true : false;
    return (
      <>
        <Switch
          defaultValue={currentValue}
          onValueChanged={(e) => cellInfo.data.setValue(e.value ? "F" : "C")}
          switchedOffText="C"
          switchedOnText="F"
        ></Switch>
      </>
    );
  };

  const renderStatus = (e) => {
    let statusTxt = {
      active: "Active",
      inactive: "Inactive",
      wip: "Inprogress",
    };
    let { colorCode, deployStatus } = e.data;
    let deployTxt = deployStatus.toLowerCase();
    return (
      <span style={{ background: colorCode }} className="stateTxt">
        {statusTxt[deployTxt]}
      </span>
    );
  };

  const onSaved = (e) => {
    if (!isSA) actions.fetchSiteList(dispatch, siteId);
    else actions.fetchSiteLists(dispatch);
    siteDataGrid.current.instance.updateDimensions();
    siteDataGrid.current.instance.refresh();
  };

  const cellEditFileUploader = (cellInfo) => {
    return (
      <>
        {cellInfo.data.value ? (
          <ManageSiteImage
            data={cellInfo.data.value}
            folderName="SiteImage"
            moreInfo={cellInfo}
            onRowUpdating={onRowUpdating}
          />
        ) : (
          ""
        )}
        {cellInfo.data.value == "DELETED" ||
        cellInfo.data.data.siteImage == "DELETED" ||
        !cellInfo.data.value ||
        cellInfo.data.value === "CORRUPTED" ? (
          <>
            <FileUploader
              selectButtonText="Select file"
              uploadMode="useForm"
              multiple={false}
              accept="image"
              labelText="Max. File Size 4 MB"
              maxFileSize={4000000}
              onValueChanged={(e) => {
                cellInfo.data.setValue(e.value);
              }}
              allowedFileExtensions={ALLOWED_IMAGE_EXTENSIONS}
            />
            <div>{fileTypeInfo(["PNG", "JPEG", "JPG", "GIF"])}</div>
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  const filePathcellRender = (data) => {
    return data.value ? (
      <a
        onClick={() => {
          let file = {
            siteImage: data.value,
            fileExtension: data.value.split(".")[1],
          };
          getTypeOfFile(file, "SiteImage");
        }}
      >
        View Attachment
      </a>
    ) : (
      ""
    );
  };

  function setStateValue(rowData, value) {
    this.defaultSetCellValue(rowData, value);
  }

  const renderSiteuid = (cellInfo) => {
    return (
      <TextBox
        defaultValue={getSiteUidValue(cellInfo)}
        disabled
        // onValueChanged={(e) =>{ cellInfo.data.data['siteUid',e.value]}}
        // onValueChanged={(ev) => {
        //   // let val = cellInfo.data.data;
        //   // val[4] = ev.value;
        //   cellInfo.data.setValue(ev.value);
        // }}
        value={getSiteUidValue(cellInfo)}
        onValueChanged={(e) => {
          // let shiftVal = [...e.value];
          // cellInfo.data["siteUid"] = shiftVal;
          // cellInfo.data.data.siteUid = e.value;
          cellInfo.data.setValue(e.previousValue);
          // cellInfo.data.data["siteUid"] = e.value;
          // cellInfo.data.setValue(e.value);
          //getSiteUidValue(cellInfo, e);
        }}
      ></TextBox>
    );

    // let grid = siteDataGrid.current.instance;
    // grid.cellValue(0, "SiteUID", `${cellInfo.data.data.sbgid}_${cellInfo.data.data.siteId}`);
    // return (
    //   <Switch
    //     defaultValue={cellInfo.data.value}
    //     onValueChanged={(e) => cellInfo.data.setValue(e.value)}
    //     switchedOffText="OFF"
    //     switchedOnText="ON"
    //   ></Switch>
    // );
  };

  const getSiteUidValue = (cellInfo) => {
    if (cellInfo.data.data.id) {
      return cellInfo.data.data.siteUid;
    }
    const isStrAvailable = (siteStr) => {
      return LIDPlantData?.lidPlant?.find(
        (obj) => obj?.siteUID?.toLowerCase() === siteStr?.toLowerCase()
      )
        ? true
        : false;
    };

    if (
      (cellInfo?.data?.data?.tierLevel === 4 ||
        cellInfo?.data?.data?.tierLevel === 8) &&
      cellInfo.data.data.siteID
    ) {
      const siteUIdStr = `${cellInfo.data.data.sbgid}_${cellInfo.data.data.siteID}`;
      if (isStrAvailable(siteUIdStr)) {
        cellInfo.data.setValue(
          `${siteUIdStr}${Math.floor(Math.random() * 10)}`
        );
        return `${siteUIdStr}${Math.floor(Math.random() * 10)}`;
      }
      cellInfo.data.setValue(siteUIdStr);
      return siteUIdStr;
    } else if (
      cellInfo.data.data.sbgid &&
      tierLevelData.find((val) => val?.key === cellInfo?.data?.data?.tierLevel)
        ?.val &&
      cellInfo.data.data.siteID
    ) {
      const siteUIdStr = `${cellInfo.data.data.sbgid}_${
        tierLevelData.find(
          (val) => val?.key === cellInfo?.data?.data?.tierLevel
        )?.val
      }_${cellInfo.data.data.siteID}`;

      if (isStrAvailable(siteUIdStr)) {
        cellInfo.data.setValue(
          `${siteUIdStr}${Math.floor(Math.random() * 10)}`
        );
        return `${siteUIdStr}${Math.floor(Math.random() * 10)}`;
      }
      cellInfo.data.setValue(siteUIdStr);
      return siteUIdStr;
    }
  };

  function getUniqueRegions() {
    if (TimezoneData && TimezoneData.length) {
      return [
        ...new Set(
          TimezoneData.map((e) => {
            return e.region;
          })
        ),
      ].map((val) => {
        return {
          region: `${val}`,
        };
      });
    } else return [];
  }

  function getFilteredTimezone(options) {
    if (TimezoneData)
      return {
        store: TimezoneData,
        filter: options.data ? ["region", "=", options.data.region] : null,
      };
  }

  const LidCodeTagBoxGrid = (props) => {
    const isActive = props?.data?.data?.tierLevel !== 4;
    if (props?.data?.data?.tierLevel > 4) {
      props.data.value = [];
    }
    const filteredData =
      compact([
        ...new Set(
          LIDPlantData?.lidPlant?.map((obj) => {
            if (
              obj.sbgid === props.data.data.sbgid &&
              obj.type === "LIDPlant"
            ) {
              return obj.lid;
            }
          })
        ),
      ]) || [];
    return (
      <TagBox
        dataSource={filteredData}
        disabled={isActive}
        defaultValue={props.data.value}
        showSelectionControls={false}
        maxDisplayedTags={3}
        showMultiTagOnly={false}
        searchEnabled={true}
        onValueChanged={(e) => {
          props.data.setValue(e.value);
        }}
      />
    );
  };

  const PlantCodeTagBoxGrid = (props) => {
    const isActive = props?.data?.data?.tierLevel !== 4;
    if (props?.data?.data?.tierLevel > 4) {
      props.data.value = [];
    }
    let filterString = [];
    if (props.data.data.lidCode && props.data.data.lidCode.length > 0) {
      props.data.data.lidCode.map((lid) => {
        filterString.push(
          [
            ["lid", "=", lid],
            "and",
            ["type", "=", "LIDPlant"],
            "and",
            ["sbgid", "=", `${props.data.data.sbgid}`],
          ],
          "or"
        );
      });
    }

    return (
      <TagBox
        disabled={isActive}
        dataSource={{
          store: LIDPlantData?.lidPlant,
          filter: props.data.data ? filterString : null,
        }}
        defaultValue={props.data.value}
        showSelectionControls={false}
        maxDisplayedTags={3}
        showMultiTagOnly={false}
        valueExpr="plantlid"
        displayExpr="plant"
        searchEnabled={true}
        onValueChanged={(e) => {
          props.data.setValue(e.value);
        }}
        onSelectionChanged={props.data.component.updateDimensions()}
      />
    );
  };

  const ChildTierTagBoxGrid = (props) => {
    const isActive = props.data.data.tierLevel > 4 ? false : true;
    if (props?.data?.data?.tierLevel === 4) {
      props.data.value = [];
    }

    return (
      <TagBox
        dataSource={{
          store: LIDPlantData?.lidPlant,
          filter: props.data.data
            ? [
                ["sbgid", "=", props.data.data.sbgid],
                "and",
                ["tierLevel", "=", props.data.data.tierLevel - 1],
                "and",
                ["siteUID", "<>", ""],
                "and",
                ["type", "=", "ChildTiers"],
              ]
            : null,
        }}
        disabled={isActive}
        defaultValue={props.data.value}
        showSelectionControls={false}
        maxDisplayedTags={3}
        showMultiTagOnly={false}
        valueExpr="siteUID"
        displayExpr="siteUID"
        searchEnabled={true}
        onValueChanged={(e) => {
          props.data.setValue(e.value);
        }}
      />
    );
  };

  const getFilteredLanguage = (options) => {
    return {
      store: languagesByRegion || [],
      filter: options?.data?.region
        ? ["region", "=", options.data.region ? options.data.region : ""]
        : "",
    };
  };

  return (
    <>
      {siteData && (
        <DataGrid
          dataSource={siteData}
          ref={siteDataGrid}
          allowColumnReordering={true}
          showBorders={true}
          {...siteGridConfig}
          onRowUpdated={onRowUpdated}
          onRowUpdating={onRowUpdating}
          onRowRemoved={onRowRemoved}
          onSaved={onSaved}
          onRowInserting={onRowInserting}
          onRowInserted={onRowInserted}
          onCellPrepared={function (e) {
            if (
              e.rowType === "filter" &&
              (e.column.dataField === "sbgid" ||
                e.column.dataField === "tierLevel" ||
                e.column.dataField === "deployStatus")
            ) {
              if (e.cellElement.firstChild)
                e.cellElement.firstChild.style.display = "none";
            }
          }}
          onContentReady={(e) => setGridUserPrefs(e, widgetId)}
          onColumnsChanging={(e) => setGridWidthPrefs(e, widgetId)}
          width="100%"
        >
          <Paging defaultPageSize={5} />
          <Pager
            visible={true}
            allowedPageSizes={[5, 10, 20, 50]}
            showPageSizeSelector={true}
            showInfo={true}
            showNavigationButtons={true}
          />
          <Column
            dataField="id"
            dataType="number"
            caption="ID"
            allowEditing={false}
            visible={false}
            showInColumnChooser={false}
          />
          <Column
            dataField="sbgid"
            caption="SBG"
            dataType="string"
            setCellValue={setStateValue}
          >
            <Lookup dataSource={["Aero", "BA", "ESS", "IA"]} />
            <RequiredRule />
          </Column>
          {isSA && (
            <Column
              dataField="tierLevel"
              caption="Tier Level"
              dataType="number"
              setCellValue={setStateValue}
            >
              <Lookup dataSource={[4, 5, 6, 7, 8]} />
              <RequiredRule />
            </Column>
          )}
          <Column
            {...{
              dataField: "siteID",
              caption: "Site",
              validationRules: [
                {
                  type: "required",
                  message: "Site is required",
                },
                {
                  type: "pattern",
                  pattern: "^[a-zA-Z0-9]+$",
                  message: "Alphabets and numbers only allowed for Site.",
                },
              ],
            }}
            dataField="siteID"
            caption="Site"
            setCellValue={setStateValue}
            allowEditing={isSA ? true : false}
          />
          <Column
            dataField="siteUid"
            caption="SiteUID"
            allowEditing={isSA ? true : false}
            editCellComponent={renderSiteuid}
          />
          <Column
            {...{
              dataField: "siteName",
              caption: "Site Name",
              validationRules: [
                {
                  type: "required",
                  message: "SiteName is required",
                },
              ],
              allowEditing: isSA ? true : false,
            }}
          />
          {isSA && (
            <Column
              dataField="region"
              caption="Region"
              dataType="string"
              setCellValue={setStateValue}
            >
              <Lookup
                dataSource={getUniqueRegions}
                valueExpr="region"
                displayExpr="region"
              />
              <RequiredRule />
            </Column>
          )}
          {isSA && (
            <Column
              dataField="timezone"
              caption="Timezone"
              dataType="string"
              setCellValue={setStateValue}
            >
              <Lookup
                dataSource={getFilteredTimezone}
                valueExpr="timeZone"
                displayExpr="timeZone"
              />
              <RequiredRule />
            </Column>
          )}

          {isSA && (
            <Column
              dataField="lidCode"
              caption="Lid Code"
              allowSorting={false}
              editCellComponent={LidCodeTagBoxGrid}
              setCellValue={setStateValue}
            ></Column>
          )}
          {isSA && (
            <Column
              dataField="plantCode"
              caption="Plant"
              allowSorting={false}
              allowEditing={false}
              formItem={{
                visible: false,
              }}
            />
          )}
          {isSA && (
            <Column
              dataField="plantlid"
              caption="Plant"
              allowSorting={false}
              editCellComponent={PlantCodeTagBoxGrid}
              setCellValue={setStateValue}
              visible={false}
            ></Column>
          )}
          <Column
            {...{
              dataField: "siteAddress",
              caption: "Site Address",
            }}
          />

          {isSA && (
            <Column
              dataField="deployStatus"
              caption="Deploy Status"
              dataType="string"
              cellRender={renderStatus}
            >
              <Lookup
                dataSource={statusTxt}
                displayExpr="val"
                valueExpr="key"
              />
              <RequiredRule />
            </Column>
          )}
          <Column
            {...{
              dataField: "siteDescription",
              caption: "Site Description",
            }}
          />
          <Column
            {...{
              dataField: "nextTierName",
              caption: "Parent Tier",
              allowEditing: false,
            }}
          />
          <Column
            {...{
              dataField: "siteLatitude",
              caption: "Latitude",
              dataType: "number",
              // format: "#,##0",
              validationRules: [
                {
                  type: "required",
                  message: "SiteLatitude is required",
                },
                {
                  type: "pattern",
                  message: "Please check the latitude pattern",
                  pattern:
                    /^[+-]?((([1-9]?[0-9]|1[0-7][0-9])(\.[0-9]{1,6})?)|180(\.0{1,6})?)$/,
                },
              ],
            }}
          />

          <Column
            {...{
              dataField: "siteLongitude",
              caption: "Longitude",
              dataType: "number",
              validationRules: [
                {
                  type: "required",
                  message: "SiteLongitude is required",
                },
                {
                  type: "pattern",
                  message: "Please check the longitude pattern",
                  pattern:
                    /^[+-]?((([1-9]?[0-9]|1[0-7][0-9])(\.[0-9]{1,6})?)|180(\.0{1,6})?)$/,
                },
              ],
            }}
          />

          <Column dataField="language" caption="Language" dataType="string">
            <Lookup
              dataSource={getFilteredLanguage}
              valueExpr="languageID"
              displayExpr="language"
              allowClearing={true}
            />
          </Column>

          <Column
            dataField="isPrivate"
            caption="Private Site"
            visible={false}
            editCellComponent={isPrivateCellRender}
            cellComponent={(d) => (d.data.value ? "ON" : "OFF")}
          />
          <Column
            dataField="tempUnit"
            caption="Temp. Unit"
            editCellComponent={editUnitCellRender}
            allowEditing={true}
            visible={true}
          />
          <Column
            {...{
              dataField: "siteImage",
              caption: "Attachments",
              allowEditing: true,
              editorOption: { allowEditing: true },
              visible: true,
            }}
            editCellComponent={cellEditFileUploader}
            cellRender={filePathcellRender}
            allowEditing={true}
            visible={true}
          />
          <Column
            {...{
              dataField: "upcomingEvent",
              caption: "Upcoming Events",
              allowEditing: true,
              editorOption: { allowEditing: true },
              visible: true,
            }}
            editCellComponent={editCellRenderUpcomingEvent}
            allowEditing={true}
            visible={true}
          />

          {isSA && (
            <Column
              dataField="childTiers"
              caption="Child Tier"
              editCellComponent={ChildTierTagBoxGrid}
              setCellValue={setStateValue}
            ></Column>
          )}
          {isSA && (
            <Column
              dataField="isSiteActive"
              caption="Active"
              visible={false}
              editCellComponent={isActiveCellRender}
              cellComponent={(d) => (d.data.value ? "ON" : "OFF")}
            />
          )}
          <Column
            fixedPosition="right"
            fixed={true}
            type="buttons"
            showInColumnChooser={false}
          >
            <Button name="edit"></Button>
            <Button name="delete"></Button>
          </Column>
        </DataGrid>
      )}
    </>
  );
};
